<template>
	<form class="form">
		<FormInput :label="$t('form.label.event.title')" v-model="form.fields.title" name="title" required />
		<FormFile :label="$t('form.label.cover_image')" v-model="form.fields.image" name="image" :maxSize="500"
			accept=".png,.jpg,.jpeg" :message="`${$t('form.messages.500_ko_3_1_ratio')} ${$t('form.messages.png_jpg')}`"
			preview required />
		<FormInput :label="$t('form.label.date')" v-model="form.fields.written_date" name="date" required />
		<FormInput :label="$t('form.label.startDate')" v-model="form.fields.start_date" name="start_date"
			:maxDate="form.fields.end_date.value" size="medium" type="date" required />
		<FormInput :label="$t('form.label.end_date')" v-model="form.fields.end_date" name="end_date"
			:minDate="form.fields.start_date.value" size="medium" type="date" required />
		<FormInput :label="$t('form.label.location')" type="text" v-model="form.fields.location" name="location" required />
		<FormInput :label="$t('form.label.url')" type="url" v-model="form.fields.participation_url" name="url"
			:message="$t('form.messages.url')" />
		<FormWysiwyg :label="$t('form.label.event.description')" v-model="form.fields.description" name="description"
			required />
	</form>
</template>

<script>
import { FormFile, FormInput, FormWysiwyg } from '@/components/form/fields'
import FormValidMixin from '@/components/form/mixins/FormValidMixin.js'

export default {
	name: 'AddEditEvent',
	mixins: [FormValidMixin],
	components: {
		FormInput,
		FormFile,
		FormWysiwyg,
	},
	data() {
		return {
			form: {
				fields: {
					description: {
						value: null,
						valid: false
					},
					end_date: {
						value: null,
						valid: false
					},
					image: {
						file: [],
						previewName: '',
						previewUrl: null,
						value: '',
						valid: false
					},
					location: {
						value: null,
						valid: false
					},
					participation_url: {
						value: null,
						valid: true
					},
					start_date: {
						value: null,
						valid: false
					},
					title: {
						value: null,
						valid: false
					},
					written_date: {
						value: null,
						valid: false
					}
				},
				submitted: false
			}
		}
	},
	methods: {
		messageToTooltip() {
			let title = this.form.fields.title.value

			if (this.$route.query.action === this.$query.ACTION.EDIT) {
				this.$popup.report(`${title} ${this.$t('popup.modifiedElement')}`, false)
			} else {
				this.$popup.report(`${title} ${this.$t('popup.createdElement')}`, false)
			}
		},
		async submit() {
			if (this.form.valid) {
				this.form.submitted = true
				const formData = {
					description: this.form.fields.description.value,
					end_date: this.form.fields.end_date.value,
					location: this.form.fields.location.value,
					participation_url: this.form.fields.participation_url.value,
					start_date: this.form.fields.start_date.value,
					title: this.form.fields.title.value,
					written_date: this.form.fields.written_date.value
				}

				let currentId
				this.$route.query.action === this.$query.ACTION.EDIT
					? currentId = await this.$event.update(this.$route.query.id, formData)
					: currentId = await this.$event.store(formData)

				if (this.form.fields.image.file) {
					await this.$event.uploadImage(currentId, this.form.fields.image.file[0])
				}

				this.form.submitted = false

				this.messageToTooltip()
			}
		},
	},
	mounted() {
		if (this.$route.query.action === this.$query.ACTION.EDIT && this.$event.all) {
			const event = Array.from(this.$event.all).find(({ id }) => id.toString() === this.$route.query.id.toString())

			this.form.fields.description = { valid: true, value: event.description }
			this.form.fields.end_date = { valid: true, value: event.end_date }
			this.form.fields.location = { valid: true, value: event.location }
			this.form.fields.participation_url = { valid: true, value: event.participation_url }
			this.form.fields.start_date = { valid: true, value: event.start_date }
			this.form.fields.title = { valid: true, value: event.title }
			this.form.fields.written_date = { valid: true, value: event.written_date }

			if (event.image) {
				this.form.fields.image.previewName = event.image.name
				this.form.fields.image.previewUrl = event.image.url
				this.form.fields.image.file = [event.image.file]
			}
		}
	}
}
</script>